// Chart.js v4 requires explicit registration of scales/controllers.
// chart.js/auto registers everything needed (CategoryScale, LinearScale, controllers, elements, etc.)
import 'chart.js/auto';

// Register plugins globally for Chart.js v4
import { Chart } from 'chart.js';
import chartjsPluginDatalabels from 'chartjs-plugin-datalabels';
import { createPeakPlugin } from './utils/peakPlugin';
Chart.register(chartjsPluginDatalabels, createPeakPlugin());

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import configureStore from './store/configureStore';
import { getClientConfiguration } from './actions/initAction';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import * as configureSolarApi from './store/configureSolarApi';
import ThemeProvider from './components/ThemeProvider';

const isAuthorized = configureSolarApi.isAuthorized();

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;

const startApp = async () => {
    await getClientConfiguration().then(_config => {
        if (_config === null) return;

        const store = configureStore(initialState);
        // ClientConfig Laden
        store.dispatch({ type: "RECEIVE_Data_clientConfigurationReducer", value: _config });

        const rootElement = document.getElementById('root');
        const root = createRoot(rootElement);

        root.render(
            <ThemeProvider>
                <Provider store={store}>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </Provider>
            </ThemeProvider>);

        registerServiceWorker();
    });
};

if (isAuthorized) {
    startApp();
} else {
    //console.log('login');
    window.location.href = 'https://login.mehl-web.de';
}
